var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50005 12.3789L15.3941 5.48413L16.4553 6.54463L8.50005 14.4999L3.72705 9.72688L4.78755 8.66638L8.50005 12.3789Z",
    fill: "#38C793"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLine);
export default __webpack_public_path__ + "static/media/check-line.349088272001bda970ce68040c2ade7e.svg";
export { ForwardRef as ReactComponent };